import { render, staticRenderFns } from "./pointsgetlog.vue?vue&type=template&id=7783373d&"
import script from "./pointsgetlog.vue?vue&type=script&lang=js&"
export * from "./pointsgetlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports